<template>
  <div>
    <v-form
        v-if="resolved"
        v-model="formIsValid"
        ref="profileForm"
        @submit="submit"
    >
      <v-row>
        <v-col
            cols="12"
            sm="6"
        >
          <v-text-field
              v-model="profileFullName"
              label="ФИО"
              :disabled="process"
              :rules="rules.fullName"
          ></v-text-field>
        </v-col>
        <v-col cols="auto">
          <v-select
              v-model="profilePhoneCode"
              class="phone-code"
              label="Телефон"
              prepend-icon="mdi-phone"
              :disabled="process"
              :items="phone.codes"
              @change="cutPhone"
          ></v-select>
        </v-col>
        <v-col>
          <v-text-field-simplemask
              v-model="profilePhone"
              :options="{
                inputMask: phone.getMask(profilePhoneCode).input,
                outputMask: phone.getMask(profilePhoneCode).output,
                empty: ''
              }"
              :properties="{
                disabled: this.process,
                placeholder: '',
                rules: rules.phone
              }"
          ></v-text-field-simplemask>
        </v-col>
      </v-row>

      <Info
          v-if="error"
          :error="error"
      ></Info>

      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-btn
              color="red"
              text
              type="button"
              :disabled="process"
              @click="$router.go(-1)"
          >
            Назад
          </v-btn>
          <v-btn
              color="primary"
              text
              type="submit"
              :disabled="process"
              :loading="process"
              @click="submit"
          >
            Обновить
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-row v-else>
      <v-col
          cols="12"
          sm="6"
      >
        <v-skeleton-loader type="heading"></v-skeleton-loader>
      </v-col>
      <v-col cols="auto">
        <v-skeleton-loader type="heading" width="75px"></v-skeleton-loader>
      </v-col>
      <v-col>
        <v-skeleton-loader type="heading"></v-skeleton-loader>
      </v-col>
    </v-row>

    <PageInfo
        title="Данная информация необходима организаторам для связи с вами"
        description="Она будет доступна организаторам только тех групп, в которых вы оформили заказы.<br/>
        Заполняя  персональные данные на странице профиля, вы даете согласие на их обработку и хранение"
    ></PageInfo>
  </div>
</template>

<script>
import Info from '@/components/Info'
import PageInfo from '@/components/PageInfo'
import {getUserProfile, setUserProfile} from '@/composables/user'
import {phone} from '@/constants'
import {showToast} from '@/services/utils'

export default {
  name: 'UserProfileCommon',
  components: {PageInfo, Info},
  computed: {
    profile () {
      return getUserProfile ()
    }
  },
  data () {
    return {
      error: null,
      profileFullName: null,
      profilePhone: null,
      profilePhoneCode: null,
      formIsValid: false,
      phone: phone,
      process: false,
      resolved: false,
      rules: {
        fullName: [
          v => !!v || 'Введите ФИО'
        ],
        phone: [
          v => !!v || 'Введите номер телефона',
          v => v && v.length === phone.getLength(this.profilePhoneCode).validation || 'Введите корректный номер'
        ]
      }
    }
  },
  methods: {
    cutPhone () {
      this.profilePhone = this.profilePhone.substring(0, phone.getLength(this.profilePhoneCode).model)
    },
    submit () {
      if (!this.formIsValid) {
        this.$refs.profileForm.validate()
        return
      }

      this.error = null
      this.process = true
      const data = this._toProfile()
      this.$client.post(this.$API.USER.PROFILE, data).then(() => {
        setUserProfile(data)
        showToast('Информация обновлена')
      })
          .catch(err => {this.error = err})
          .finally(() => this.process = false)
    },
    _toProfile () {
      return {
        fullName: this.profileFullName,
        phone: this.profilePhone,
        phoneCode: this.profilePhoneCode
      }
    }
  },
  watch: {
    'profile.resolved': {
      handler (val) {
        this.resolved = val
      },
      immediate: true
    },
    'profile.fullName': {
      handler (val) {
        this.profileFullName = val
      },
      immediate: true
    },
    'profile.phone': {
      handler (val) {
        this.profilePhone = val
      },
      immediate: true
    },'profile.phoneCode': {
      handler (val) {
        this.profilePhoneCode = val
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.phone-code {
  width: 102px;
}
</style>